import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import MainHeader from "../components/MainHeader";
import { toast } from "sonner";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { register, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.remove("theme-mini");
  }, []);
  useEffect(() => {
    if (user && user.id) navigate("/");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(email, password, name);
      toast.success("Welcome to Green Screen.");
      navigate("/");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="register-page" className="min-h-screen bg-gs-cream">
      <MainHeader />
      <div className="max-w-md mx-auto px-6 py-20">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gs-ember">First time visitor</p>
        <h1 className="font-serif text-5xl text-gs-ink mt-3 leading-tight">Get a ticket</h1>
        <p className="font-sans text-gs-ink/70 mt-3">Create your account to rent or buy a film.</p>

        <form onSubmit={submit} className="mt-10 space-y-5" data-testid="register-form">
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-gs-dust mb-2">Name</label>
            <input
              data-testid="register-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="w-full bg-white border border-gs-line px-4 py-3 font-sans focus:outline-none focus:border-gs-ember"
            />
          </div>
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-gs-dust mb-2">Email</label>
            <input
              data-testid="register-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-white border border-gs-line px-4 py-3 font-sans focus:outline-none focus:border-gs-ember"
            />
          </div>
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-gs-dust mb-2">Password</label>
            <input
              data-testid="register-password-input"
              type="password"
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-white border border-gs-line px-4 py-3 font-sans focus:outline-none focus:border-gs-ember"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="register-submit-btn"
            className="w-full bg-gs-ink text-gs-cream py-3 font-mono uppercase tracking-[0.25em] text-xs border border-gs-ember/50 hover:bg-gs-ember hover:text-gs-ink rounded-none transition-colors disabled:opacity-60"
          >
            {busy ? "Creating…" : "Create account"}
          </button>
        </form>

        <p className="font-sans text-sm text-gs-ink/60 mt-6">
          Already have an account? <Link to="/login" className="text-gs-ember underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
